













import {Component, Vue, Prop} from "vue-property-decorator";
import AttributeSet from "@/api/AttributeSet";
import Product from "@/api/Product";
import RenderProductPrice from "@/components/Shared/RenderProductPrice.vue";
import CompareTableHeaderCell from "@/components/Compare/CompareTable/CompareTableHeaderCell.vue";
import CompareTableHeaderAdd from "@/components/Compare/CompareTable/CompareTableHeaderAdd.vue";

@Component({
  components: {CompareTableHeaderAdd, CompareTableHeaderCell, RenderProductPrice}
})
export default class CompareTableHeader extends Vue {
  @Prop() private products!: Product[];
  @Prop() private attributeSet!: AttributeSet;
  @Prop({default: true}) private isMobile!: boolean;

  private sticky = false;
  private scrollYValue = 0;

  private initialHeight = 0;

  handleScroll() {
    this.scrollYValue = window.scrollY;
  }

  mounted() {
    window.addEventListener('scroll', this.checkSticky);
  }

  setInitialHeight() {
    console.log("WindowsLoad");
    const headerWrapper: HTMLElement = this.$refs['headerWrapper'] as HTMLElement;

  }

  checkSticky() {
    this.handleScroll();
    this.sticky = this.scrollYValue > 270;
    this.setHeaderHeight();
  }

  setHeaderHeight() {
    const headerWrapper: HTMLElement = this.$refs['headerWrapper'] as HTMLElement;
    const headerInner: HTMLElement = this.$refs['headerInner'] as HTMLElement;
    if (this.sticky) {
      if(this.initialHeight > 0) {
        headerWrapper.style.height = this.initialHeight + "px";
      }else{
        headerWrapper.style.height = headerInner.offsetHeight + "px";
      }
    } else {
      headerWrapper.style.height = "auto";
      this.initialHeight = headerWrapper.offsetHeight;
    }
  }

  get stickyClass() {
    if (this.sticky) {
      return "sticky";
    }
    return '';
  }

  get showAddCell() {
    if (this.isMobile) {
      return this.products.length < 2;
    }
    return this.products.length < 4;
  }

  removeProduct(productId: number) {
    this.$emit("product-remove", productId);
  }
}
